import { Box, Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getScheduleStatus, get_adhoc_schedule, get_completed_schedule, get_ongoing_schedule, get_schedule, mergeMapsToArray, setApproveSchedule, updateSchedule } from './utils/helpers';
import { schedule_table_headers, static_completed_table_headers } from './utils/schedule_table_format';
// import PaginatedDataGrid from '../../common/components/Table/NonPaginatedDataGrid';
import ContainedButton from '../../common/components/Buttons/ContainedButton';
import { Render_output_remarks_cell } from './utils/schedule_datagrid_cell_renderer';
import getErrorMessage, { fetch_hidden_fields, } from '../../util';
import ScheduleComponent from './components/ScheduleComponent';
import { utils, writeFile } from 'xlsx';
import TimeDatePicker from './components/TimeDatePicker';
// import axiosInstance from '../../http-common';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import LinearLoadingState from '../../common/components/LoadingState/LinearLoadingState';
import SnackbarWithMessage from '../../common/components/Snackbars/SnackbarWithMessage';
import AnalystDropdown from './components/AnalystDropdown';
import MachineDropdown from './components/MachineDropdown';
import StaticCompletedTable from './components/StaticCompletedTable';
import { mixpanelTrackButton } from '../../mixPanelFunctions/mixPanelFunctions';

function generateDateWithTime(hour, minute, second) {
  const now = new Date();
  now.setHours(hour);
  now.setMinutes(minute);
  now.setSeconds(second);
  return now;
}

// const sixAMDate = generateDateWithTime(6, 0, 0);
// console.log(sixAMDate);


const Output = () => {
  // const [finalized, set_finalized] = useState(false);
  const [edit_enabled, set_edit_enabled] = useState(false);
  const [entire_schedule, set_entire_schedule] = useState([]);
  const [todays_schedule, set_todays_schedule] = useState([]);
  const [future_schedule, set_future_schedule] = useState([]);
  const [adhoc_schedule, set_adhoc_schedule] = useState([]);
  const [completed_schedule, set_completed_schedule] = useState([]);
  const ongoingScheduleRef = useGridApiRef();
  const todaysScheduleRef = useGridApiRef();
  const upcomingScheduleRef = useGridApiRef();
  const adhocScheduleRef = useGridApiRef();
  const [scheduleStatus, setScheduleStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });
  const [
    // past_schedule
    , set_past_schedule] = useState([]);
  const [ongoing_schedule, set_ongoing_schedule] = useState([]);

  const initialize_schedule = async () => {
    // console.log("getting schedule");
    const response = await get_schedule();
    // console.log(response);
    const ongoing_response = await get_ongoing_schedule();
    const adhoc_response = await get_adhoc_schedule();
    const completed_response = await get_completed_schedule();

    // console.log(adhoc_response);
    if (response?.status !== "failure" && response?.qc_schedule && ongoing_response.status !== "failure" && ongoing_response?.ongoing_schedule?.length >= 0) {
      set_entire_schedule(response.qc_schedule);
      const data = response?.qc_schedule;
      const ongoing_data = ongoing_response.ongoing_schedule;
      const adhoc_data = adhoc_response?.adhoc_schedule;
      const completed_data = completed_response?.completed_schedule;
      // console.log(data)
      // console.log({ schedule_data: data, ongoing_data });
      const today_ts = generateDateWithTime(0, 0, 0);
      const today_date = today_ts.getDate();
      const today_month = today_ts.getMonth() + 1;
      const today_year = today_ts.getFullYear();
      const today_date_string = `${today_year}-${today_month}-${today_date}`;
      // console.log({ today_date_string });
      const today = today_ts.getTime();
      // const one_day_in_ms = 1000 * 60 * 60 * 24;
      // const one_day_in_ms = 59400002;
      // const day_end_time = today + one_day_in_ms;
      // console.log(new Date(day_end_time));
      const previous = [];
      const upcoming = [];
      const same_day = [];
      data?.forEach(schedule => {
        // console.log(schedule);
        try {
          const start_ts = schedule?.pre_start_time;
          const start_date = start_ts.getDate();
          const start_month = start_ts.getMonth() + 1;
          const start_year = start_ts.getFullYear();
          const start_date_string = `${start_year}-${start_month}-${start_date}`;
          const start_time = start_ts?.getTime();
          // if (end_time > day_end_time) {
          //   upcoming.push(schedule);
          // }
          // else 
          if (today_date_string === start_date_string) {
            same_day.push(schedule);
          }
          else if (start_time < today) {
            previous.push(schedule);
          }
          else {
            upcoming.push(schedule);
          }
          // else {
          //   same_day.push(schedule);
          // }
        } catch (error) {
          const error_message = getErrorMessage(error);
          console.error(error_message);
        }
      });
      // console.log({
      //   previous,
      //   same_day,
      //   upcoming,
      // });
      set_ongoing_schedule(ongoing_data);
      set_todays_schedule(same_day);
      set_future_schedule(upcoming);
      set_past_schedule(previous);
      set_adhoc_schedule(adhoc_data);
      set_completed_schedule(completed_data);
    }
    // console.log({ response, ongoing_response });
  };
  const toggle_edit = async () => {
    if (edit_enabled) {
      // console.log(entire_schedule);
      // const ongoingData = ongoingScheduleRef.current.getRowModels();
      const todaysData = todaysScheduleRef.current?.getRowModels();
      const upcomingData = upcomingScheduleRef.current?.getRowModels();
      // merging maps to array
      const tempCompleteScheduleData = mergeMapsToArray(todaysData, upcomingData);
      await updateSchedule(tempCompleteScheduleData);
      await getScheduleStatus(setScheduleStatus, setLoading);
      await initialize_schedule();
      set_open_snackbar_with_message({ open: true, message: `Schedule Saved!`, severity: "success" });
      // console.log(tempCompleteScheduleData);
      mixpanelTrackButton("output","save schedule") // mixpanel track button
    }
    set_edit_enabled(prev => !prev);
  };
  const handle_schedule_download = () => {
    mixpanelTrackButton("output","download schedule") // mixpanel track button
    const worksheet = utils.json_to_sheet(entire_schedule.map(item => {
      delete item.id;
      return item;
    }));
    // utils.sheet_add_aoa(worksheet, [[...config.columnNames]], {
    //   origin: 'A1',
    // });

    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Data Sheet");
    writeFile(workbook, `Schedule.xlsx`, { compression: true });
  };
  const handle_approve_schedule = async () => {
    // console.log("Schedule Approved");
    // const ongoingData = ongoingScheduleRef.current.getRowModels();
    const todaysData = todaysScheduleRef.current?.getRowModels();
    const upcomingData = upcomingScheduleRef.current?.getRowModels();
    // merging maps to array
    const tempCompleteScheduleData = mergeMapsToArray(todaysData, upcomingData);
    await setApproveSchedule(tempCompleteScheduleData);
    await getScheduleStatus(setScheduleStatus, setLoading);
    await initialize_schedule();
    set_open_snackbar_with_message({ open: true, message: `Schedule Approved!`, severity: "success" });
    // console.log(tempCompleteScheduleData);
    mixpanelTrackButton("output","approve schedule") // mixpanel track button
  };
  const handle_cancel_schedule = async () => {
    console.log("cacnel");
    await initialize_schedule();
    set_edit_enabled((prev) => !prev);
    mixpanelTrackButton("output","cancel schedule") // mixpanel track button
  };
  // console.log(scheduleStatus);
  const [columns, set_columns] = useState(Object.values(schedule_table_headers));


  // const schedule_interval_ref = useRef(null);
  // console.log(scheduleStatus);
  useEffect(() => {
    getScheduleStatus(setScheduleStatus, setLoading);
    initialize_schedule();
    // get_adhoc_schedule()
    // if (!schedule_interval_ref.current) {
    //   schedule_interval_ref.current = setInterval(() => {
    //     initialize_schedule();
    //   }, 15000);
    // }
    // initialize_schedule();
    // get_analyst_list().then(data => {
    //   let temp = [...columns].map((item) => {
    //     if (item.field === "analyst_id") {
    //       return {
    //         ...item,
    //         type: "singleSelect",
    //         valueOptions: data.map(analyst_data => ({
    //           label: analyst_data.analyst_id,
    //           value: analyst_data.analyst_id
    //         })),
    //         // editable: true
    //       };
    //     }
    //     return item;
    //   });
    //   set_columns(temp);
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // return () => {
    //   if (schedule_interval_ref.current) {
    //     clearInterval(schedule_interval_ref.current);
    //   }
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (todays_schedule.length > 0) {
  //     // console.log({ todays_schedule });
  //     // console.log(columns);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [todays_schedule]);

  // const get_todays_schedule = () => {
  //   return todays_schedule;
  // };

  // const update_analyst = ({ analyst_id, batch_no, step_name, }, new_analyst_id, todays_schedule) => {
  //   // console.log({ new_analyst_id });
  //   console.log({ analyst_id, batch_no, step_name });
  //   const temp_todays_schedule = todays_schedule.slice().map(item => {
  //     if (item.analyst_id === analyst_id && item.batch_no === batch_no && item.step_name === step_name) {
  //       // console.log({ item });
  //       return {
  //         ...item,
  //         analyst_id: new_analyst_id
  //       };
  //     }
  //     return item;
  //   });
  //   console.log({ temp_todays_schedule });
  //   // set_todays_schedule(temp_todays_schedule);
  // };


  const [hidden_fields, set_hidden_fields] = useState({
    open_po: [],
    sample_status: [],
    schedule: [],
  });

  useEffect(() => {
    fetch_hidden_fields(set_hidden_fields);
  }, []);

  useEffect(() => {
    // console.log("useeffect called");
    const editable_fields = ["pre_start_time", "machine_start_time", "pre_end_time", "machine_end_time", "machine_id", "analyst_id", "status"];
    if (edit_enabled) {
      set_columns((prev) => {
        console.log(prev);
        const updatedColumns = prev.map(column => {
          const field = column.field;
          console.log(field);
          if (editable_fields.includes(field)) {
            if (field === "analyst_id") {
              return {
                ...column,
                width: 150,
                renderCell: (props) => <AnalystDropdown {...props} />,
                editable: true,
              };
            }
            else if (field === "machine_id") {
              return {
                ...column,
                width: 150,
                // renderCell: (props) => {
                //   return render_select_analyst_cell(props, update_analyst, todays_schedule);
                // }
                editable: true,
                renderCell: (props) => <MachineDropdown {...props} />,
              };
            }
            else if (field === "machine_start_time" || field === "machine_end_time" || field === "pre_start_time" || field === "pre_end_time") {
              return {
                ...column,
                editable: false,
                renderCell: (props) => <TimeDatePicker {...props} />
              };
            }
            return {
              ...column,
              editable: true
            };
          }
          // else if (field === "status") {
          //   console.log("Setting rendercell for status");
          //   return {
          //     ...column,
          //     renderCell: Render_output_remarks_cell
          //   }
          // }
          else {
            return {
              ...column
            };
          }
        });
        // console.log('updated', updatedColumns);
        return updatedColumns;
      });
    }
    else {
      set_columns((prev) => {
        const updatedColumns = prev.map(column => {
          const field = column.field;
          if (editable_fields.includes(field)) {
            console.log(field);
            if (field === "analyst_id" || field === "machine_id") {
              return {
                ...column,
                editable: false,
                width: 100,
                renderCell: null,
              };
            }
            else if (field === "machine_id") {
              return {
                ...column,
                width: 100,
                editable: false,
                renderCell: null
              };
            }
            else if (field === "pre_start_time" || field === "pre_end_time" || field === "machine_start_time" || field === "machine_end_time") {
              return {
                ...column,
                editable: false,
                renderCell: null
              };
            }
            // else if (field === "status") {
            //   return {
            //     ...column,
            //     renderCell: render_output_remarks_cell
            //   };
            // }
            return {
              ...column,
              editable: false,
            };
          }
          else if (field === "remark") {
            return {
              ...column,
              editable: false,
              width: 100,
            };
          }
          else if (field === "status") {
            return {
              ...column,
              editable: false,
              renderCell: Render_output_remarks_cell
            };
          }
          else {
            return {
              ...column
            };
          }
        });
        console.log("updated", updatedColumns);
        return updatedColumns;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit_enabled]);
  return (
    <Box className="mb-4">
      <Box
        className="p-4 px-8"
        sx={{
          width: "100%",
          color: "black",
          fontSize: "28px",
          fontFamily: "Poppins",
          fontWeight: 400,
          lineHeight: "36px",
          wordWrap: "break-word",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // border: "1px solid black",
        }}
      >
        {/* {`${scheduleStatus === "approved" ? "Approved Schedule" : "Current Schedule"} `} */}
        <p className='capitalize'>{scheduleStatus} Schedule</p>
        <br />
        {loading ? <LinearLoadingState /> : <Box className="flex justify-center items-center gap-4">
          {
            !edit_enabled && todays_schedule.length > 0 &&
            <ContainedButton variant='outlined' disabled={scheduleStatus === "approved"} handleClick={handle_approve_schedule} >Approve Schedule</ContainedButton>
          }
          {
            edit_enabled && entire_schedule.length > 0 &&
            <ContainedButton variant='outlined' handleClick={handle_cancel_schedule} >Cancel</ContainedButton>
          }
          {
            todays_schedule.length > 0 &&
            <ContainedButton variant='outlined' disabled={scheduleStatus === "approved"} handleClick={toggle_edit} >{edit_enabled ? "Save" : "Update Schedule"}</ContainedButton>
          }
          {
            entire_schedule.length > 0 &&
            <ContainedButton variant='outlined' handleClick={handle_schedule_download} >Download Schedule</ContainedButton>
          }

        </Box>}
      </Box>
      <Container maxWidth="xl">
        <Box>
          <ScheduleComponent hidden_fields={hidden_fields?.schedule} columns={columns} schedule={ongoing_schedule} set_schedule={set_ongoing_schedule} title={"In Progress Schedule"} height={ongoing_schedule?.length > 0 ? 250 : 150} edit_enabled={edit_enabled} gridApiRef={ongoingScheduleRef} editRowStatus={true} aria_label={"ongoing_table"} />
        </Box>
        <Box>
          <ScheduleComponent hidden_fields={hidden_fields?.schedule} columns={columns} schedule={todays_schedule} title={"Today's Schedule"} show_count height={600} has_new_schedule_row gridApiRef={todaysScheduleRef} edit_enabled={edit_enabled} editRowStatus={scheduleStatus && scheduleStatus === "approved"} scheduleStatus={scheduleStatus && scheduleStatus} aria_label={"today_table"} />
        </Box>
        <Box>
          <ScheduleComponent hidden_fields={hidden_fields?.schedule} columns={columns} schedule={future_schedule} title={"Upcoming Schedule"} show_count height={300} gridApiRef={upcomingScheduleRef} edit_enabled={edit_enabled} editRowStatus={scheduleStatus && scheduleStatus === "approved"} scheduleStatus={scheduleStatus && scheduleStatus} aria_label={"upcoming_table"} />
        </Box>
        <Box>
          <ScheduleComponent hidden_fields={[...hidden_fields?.schedule, "status"]} columns={columns} schedule={adhoc_schedule} title={"Tasks Pending Approval"} show_count height={300} gridApiRef={adhocScheduleRef} edit_enabled={edit_enabled} editRowStatus={scheduleStatus && scheduleStatus === "approved"} scheduleStatus={scheduleStatus && scheduleStatus} aria_label={"adhoc_table"} initialState={{ pinnedColumns: { left: ["batch_number", "batch_no", "material_name", "product_name"], right: ["analyst_id", "machine_id", "approval"] } }} />
        </Box>
        {/* <PaginatedDataGrid
        /> */}
        <Box>
          {completed_schedule && completed_schedule?.length > 0 && <StaticCompletedTable hidden_fields={hidden_fields?.schedule} columns={static_completed_table_headers} schedule={completed_schedule} title={"Completed Schedule"} show_count height={300} aria_label={"completed_table"} />}
        </Box>
      </Container>
      <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
        set_open_snackbar_with_message({
          open: false,
          message: "",
          severity: "info"
        });
      }} />
    </Box >
  );
};

export default Output;